import { defineMessages } from 'react-intl'

const scope = `procurify.audit-log.components.AuditLogRecordChange`

export default defineMessages({
  noneLabel: {
    id: `${scope}.noneLabel`,
    defaultMessage: 'None',
  },
})
